import css from "./Pills.module.css";

const Pills = ({ text }) => {
  return <div className={css.Pills}>{text}</div>;
};

export default Pills;
